import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import PanelCard from './PanelCard';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    right: {
        paddingLeft: "1rem",
    },
    start: {
        
    },
    element: {
        marginBottom: "1rem",
        marginTop: "1rem",

    },
    container: {
        marginLeft: 'auto',
        textAlign: 'center',
        marginRight: 'auto',
        marginTop: "2rem",
        width: "400px",
        maxWidth: "100%"
    }
  }));


const Panels = ({active, next, info, state, change, packages}) => {
    const [panel, setPanel] = React.useState(info.front.products.selectedPanelType || packages[0]?.panel);
    const [inverter, setInverter] = React.useState(info.front.products.selectedInverterType || packages[0]?.inverter);
    const [optimizer, setOptimizer] = React.useState(info.front.optimizers.hasOptimizer || packages[0]?.optimizer);
    const [battery, setBattery] = React.useState(info?.front?.batteries[0] || packages[0]?.battery)
    const [wallbox, setWallbox] = React.useState(info?.front?.wallbox[0] || packages[0]?.wallbox)
    const [image, setImage] = React.useState(packages.find(p => p.panel === info.front.products.selectedPanelType)?.image || packages[0]?.image)
    const [accessories, setAccessories] = React.useState([!!info?.front?.wallbox[0] && "wallbox", !!info?.front?.batteries[0] && "battery"].filter(a => !!a));
    const [selectedAccessories, setSelectedAccessories] = React.useState({});    
    React.useEffect(() => {
        let selected = {
            wallbox: accessories.includes("wallbox") ? [wallbox ?? 0] : [], 
            batteries: accessories.includes("battery") ? [battery ?? 0] : [],
        }
        setSelectedAccessories(selected);
    }, [accessories, battery, wallbox])


    React.useEffect(() => {
        setImage(packages.find(p => p.panel === info.front.products.selectedPanelType)?.image)
    }, [info, packages])

    React.useEffect(() => {
        change({...state, ...selectedAccessories, optimizers: {...state.optimizers, wantsOptimizer: optimizer}, products: {...state.products, panelType: panel, inverterFamily: inverter}})
    }, [panel, inverter, optimizer, battery, wallbox, selectedAccessories])

    const classes = useStyles();
    return <>
        {image && <Box style={{height: 400}}>
            <img style={{objectFit: "cover"}} src={image} alt="Bild på tak" width="100%" height="100%"/>
        </Box>}
    <Container><Grid container spacing={3} className={classes.container}>


    <Grid item xs={12} >
            <Typography variant="h3" className={classes.element}>Panelpaket</Typography>
            <Typography variant="subtitle1"  className={classes.element}>Välj vilken typ av solpaneler du är ute efter, samt vilka tillbehör du är intresserad av.</Typography>
    </Grid>
    {packages.map(p => {
        return (<Grid item xs={12}>
        <PanelCard selectedValue={panel} handleChange={(panel, inverter, optimizer, image, battery, wallbox) => {setPanel(panel); setInverter(inverter); setOptimizer(optimizer); setImage(image); setBattery(battery); setWallbox(wallbox)}} {...p}/>
    </Grid>)
    })}
    <Grid item xs={12} >
            <Typography variant="h4" className={classes.element}>Välj tillbehör</Typography>
    </Grid>
    <Grid item xs={12} >
    
    <ToggleButtonGroup style={{width: "100%"}} value={accessories} onChange={(event, newValue) => setAccessories(newValue)}>
        <ToggleButton style={{width: "50%"}} color="primary" value="battery">
            Energilager
        </ToggleButton>
        <ToggleButton style={{width: "50%"}} color="primary" value="wallbox">
            Laddbox
        </ToggleButton>
      </ToggleButtonGroup>
    </Grid>
    
    <Grid item xs={12} style={{maxWidth: "400px", marginLeft: "auto", marginRight: "auto"}}>
        <Button color="primary" onClick={event => next()} fullWidth size="large" variant="outlined" className={classes.element}>Fortsätt</Button>
    </Grid>
</Grid></Container></>
};

export default Panels;